import lambdaApi from 'api/LambdaApi';
import { AxiosError } from 'axios';
import { ReferenceNotesDataModel } from 'generated-types/skills/customer_references';
import { useQuery } from 'react-query';

interface UseReferenceNotesReturn {
    referenceNotesData: string;
    isReferenceNotesLoading: boolean;
    refetchReferenceNotes: () => void;
    isReferenceNotesError: boolean;
}

const parseNotesData = (data: ReferenceNotesDataModel | undefined) => {
    let notes = '';
    if (data) {
        for (const item of data.notesData) {
            const durationYears = Math.floor(item.durationMonths / 12);
            const durationMonths = item.durationMonths % 12;
            if (notes !== '') notes += '\n\n';
            notes += 'Role: ' + item.experienceTitle;
            if (durationYears > 0) {
                notes += ' ' + durationYears + 'v';
            }
            notes += ' ' + durationMonths + 'kk';
            notes += ' (' + item.consultants.toString().replace(/,/g, ', ') + ').';
            notes += '\nSkills: ' + item.skills.toString().replace(/,/g, ', ') + ')';
            notes += '\n' + item.experienceDesc;
        }
    }
    if (notes === '') notes = 'No experiences found in skills DB.';
    return notes;
};

const useReferenceNotesHook = (customerId: number | undefined): UseReferenceNotesReturn => {
    const { data, isLoading, refetch, isError } = useQuery<ReferenceNotesDataModel, AxiosError>(
        ['customer_references', customerId],
        async () => {
            if (customerId) {
                const referencesUri = `/skills/customer-references/notes/${customerId}`;
                const res = await lambdaApi
                    .get<ReferenceNotesDataModel>(referencesUri)
                    .then(res => res.data);
                return res;
            } else {
                return { notesData: [] };
            }
        },
        {
            retry: false,
            enabled: !!customerId,
        },
    );

    return {
        referenceNotesData: parseNotesData(data),
        isReferenceNotesLoading: isLoading,
        refetchReferenceNotes: refetch,
        isReferenceNotesError: isError,
    };
};

export { useReferenceNotesHook };
